import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import WatermarkTool from './pages/WatermarkTool'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/watermark" element={<WatermarkTool />} />
      </Routes>
    </Layout>
  )
}

export default App